const filterReportDinasToo = {
    idKelas: null,
    idProfilCbt: null,
    typeReport: "TOO"
}

export default filterReportDinasToo;